import { createReducer } from './utils'

export default createReducer({
    POSTS_LOADED: (state, action) => {
        console.log('POSTS_LOADED', state, action)
        const entries = action.data.entries;
        const posts = {}
        for (var i = entries.length - 1; i >= 0; i--) {
            const entry = entries[i];
            posts[entry._id] = entry
        }

        return posts;
    }
})




// WEBPACK FOOTER //
// ./src/reducers/posts.jsx